import { useToastManager } from "@porsche-design-system/components-react"
import { useCallback } from "react"
import { useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"

interface UseCopyToClipboardProps {
	onCopied?: (value: string) => void // for tracking and other side effects
	successToastText?: string
	value: string
}

export const useCopyToClipboard = ({ onCopied, successToastText, value }: UseCopyToClipboardProps) => {
	const { addMessage } = useToastManager()
	const { formatMessage } = useIntl()

	return useCallback(() => {
		navigator.clipboard.writeText(value).then(() => {
			addMessage({
				state: "success",
				text: successToastText ?? formatMessage(commonMessages.copyToClipboardSuccess, { value }),
			})
			onCopied?.(value)
		})
	}, [value, addMessage, successToastText, formatMessage, onCopied])
}
